export enum DynamicFormLinkType {
  EXISTS_FOR_VALUES = 'EXISTS_FOR_VALUES',
  EXISTS_FOR_CUSTOM_PROPERTY = 'EXISTS_FOR_CUSTOM_PROPERTY',
}
